import { FormOfWayType, FunctionalRoadClassType } from 'app/models/enums';

export class OpenLRLineAttributes {
  openlrBearing: number;
  openlrFormOfWay: FormOfWayType;
  openlrFunctionalRoadClass: FunctionalRoadClassType;
}



// WEBPACK FOOTER //
// ./src/app/models/openlr/openlrlineattributes.model.ts